/**
 * A recorded entry is made of "question\nanswer" blocks separated by a blank
 * line (composeActivityEntry). A block without a question line is an answer on
 * its own (older entries, and answers recorded outside a question frame).
 */
export type EntryBlock = { question: string; answer: string };

export const entryBlocks = (entry: string): EntryBlock[] =>
  entry
    .split('\n\n')
    .map(block => {
      const lines = block.split('\n');
      const question = (lines[0] || '').trim();
      const answer = lines.slice(1).join('\n').trim();
      return answer ? { question, answer } : { question: '', answer: question };
    })
    .filter(block => block.answer.length > 0);

const ENTRY_PREVIEW_LENGTH = 90;

/** the diary text comes last, after the check-in frames: preview the LAST answer, never a question */
export const entryPreview = (entry: string): string => {
  const answers = entryBlocks(entry).map(block => block.answer.replace(/\n/g, ' '));
  const lastAnswer = answers[answers.length - 1] || '';
  const cut = lastAnswer.slice(0, ENTRY_PREVIEW_LENGTH);
  return cut.length < lastAnswer.length ? cut.trimEnd() + '…' : cut;
};
